import { useTranslation } from 'react-i18next';
import { StatusBanner } from '@shared/ui';

interface PasswordChangeWarningProps {
  emphasizeCurrentToken?: boolean;
}

export function PasswordChangeWarning({ emphasizeCurrentToken = false }: PasswordChangeWarningProps) {
  const { t } = useTranslation('auth');

  return (
    <StatusBanner variant="pending" role="note">
      <p className="font-semibold">{t('recovery.warningTitle')}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        <li>
          {t('recovery.warningWithdrawalsLead')}{' '}
          <strong>{t('recovery.warningWithdrawalsStrong')}</strong>
        </li>
        <li>
          <strong>{t('recovery.warningApiStrong')}</strong> {t('recovery.warningApiRest')}
        </li>
        <li>{t('recovery.warningSessions')}</li>
      </ul>
      {emphasizeCurrentToken && (
        <p className="mt-3 font-semibold">{t('recovery.warningCurrentToken')}</p>
      )}
    </StatusBanner>
  );
}
